import React from "react";

const SpeedTestResult = ({ result, getTextByKey, fileSize, sizeType }) => {
  return (
    <div
      className={`results-container-display ${
        result ? "show-all-height" : null
      }`}
    >
      {result && result === "error" ? (
        <div>{getTextByKey("numbers-not-valid")}</div>
      ) : (
        <>
          <h4 id="speed-results-header">
            {getTextByKey("speed-calc-duration")}
          </h4>
          <p id="speed-upload-duration">{result}</p>
          <h4 id="speed-results-footer">
            {`${getTextByKey("speed-calc-time")}  ${fileSize} ${sizeType}
          `}
          </h4>
        </>
      )}
    </div>
  );
};

export default SpeedTestResult;
